<template>
  <div>
    <div class="row gx-2">
      <div class="mb-2 col">
        <div class="d-flex">
          <label class="form-label">
            Reason
          </label>
          <div
            v-if="isEditable"
            class="ms-auto"
          >
            <button
              v-if="!isEditMode"
              type="button"
              class="btn btn-sm btn-success btn-tight"
              @click.prevent="toggleEditMode"
            >
              Edit
            </button>
            <button
              v-if="isEditMode"
              type="button"
              class="btn btn-sm btn-primary btn-tight"
              @click.prevent="saveCancellationReason"
            >
              Save
            </button>
            <button
              v-if="isEditMode"
              type="button"
              class="btn btn-sm btn-secondary btn-tight"
              @click.prevent="toggleEditMode"
            >
              Cancel
            </button>
          </div>
        </div>
        <textarea
          v-model="cancellationReasonValue"
          class="form-control"
          :readonly="!isEditMode || isSaving"
        />
      </div>
    </div>
    <loading-indicator
      v-if="isSaving"
      message="Saving data ..."
    />
  </div>
</template>

<script setup lang="ts">
import {computed, ref, watch} from 'vue'
import axios from 'axios'
import Rails from '@rails/ujs'

import LoadingIndicator from '../loading-indicator.vue'
import { isNonEmptyString } from '@/js/js-utils'
import { getAxiosError } from '@/js/axios-utils'

const props = defineProps({
  cancellationReason: { type: String, default: "" },
  updateUrl: { type: String, default: "" },
})

const isEditMode = ref(false)
const isSaving = ref(false)
const originalCancellationReason = ref(props.cancellationReason)
const cancellationReasonValue = ref(props.cancellationReason)

const isEditable = computed((): boolean => isNonEmptyString(props.updateUrl))

watch(() => props.cancellationReason, (val): void => {
  cancellationReasonValue.value = val
  originalCancellationReason.value = val
})

const toggleEditMode = (): void => {
  isEditMode.value = !isEditMode.value
  if (!isEditMode.value) {
    isSaving.value = false
    cancellationReasonValue.value = originalCancellationReason.value
  }
}

const saveCancellationReason = (): void => {
  isSaving.value = true

  axios.patch(props.updateUrl, {
    cancelation_reason: cancellationReasonValue.value
  }, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': Rails.csrfToken()
    }
  })
    .then((_response) => {
      isEditMode.value = false
      originalCancellationReason.value = cancellationReasonValue.value
    })
    .catch((error) => {
      alert(`An error occurred: ${getAxiosError(error)}`)
    })
    .then(() => {
      isSaving.value = false
    })
}
</script>
